(function ($, window, document) {
    'use strict';

    function placeholder($select) {
        return $select.data('placeholder') || $select.find('option:first').text() || 'Select option';
    }

    function setOptions($select, records, selectedValue) {
        $select.empty().append(new Option(placeholder($select), '', true, false));

        $.each(records || [], function (index, record) {
            $select.append(new Option(record.text, record.id, false, false));
        });

        $select.val(selectedValue || '').trigger('change');
    }

    function resetOptions($selects) {
        $selects.each(function () {
            setOptions($(this), []);
        });
    }

    function refreshTaskAreas($context) {
        var $area = $context.find('.js-task-area-target');

        if (!$area.length) {
            return;
        }

        var $project = $($area.data('project'));
        var $floor = $($area.data('floor'));
        var $locationType = $($area.data('location-type'));
        var projectId = $project.val();
        var floorId = $floor.val();
        var locationTypeId = $locationType.val();

        if (!projectId || !floorId || !locationTypeId) {
            setOptions($area, []);
            return;
        }

        $.getJSON($area.data('url'), {
            project_id: projectId,
            floor_id: floorId,
            location_type_id: locationTypeId
        }, function (response) {
            setOptions($area, response.data || []);
        });
    }

    $(document).on('change', '.js-project-floor-source', function () {
        var $project = $(this);
        var $floor = $($project.data('target'));
        var $building = $($project.data('building-target'));
        var $resetTarget = $($project.data('reset-target'));
        var projectId = $project.val();
        var url = $project.data('url');
        var buildingUrl = $project.data('building-url');
        var $form = $project.closest('form');

        if (!$floor.length) {
            return;
        }

        if ($resetTarget.length) {
            resetOptions($resetTarget);
        }

        if (!projectId) {
            setOptions($floor, []);
            if ($building.length) {
                setOptions($building, []);
            }
            refreshTaskAreas($form);
            return;
        }

        $.getJSON(url + '/' + projectId, function (response) {
            setOptions($floor, response.data || []);
        });

        if ($building.length && buildingUrl) {
            $.getJSON(buildingUrl + '/' + projectId, function (response) {
                setOptions($building, response.data || []);
            });
        }
    });

    $(document).on('change', '.js-floor-area-source', function () {
        var $floor = $(this);
        var $area = $($floor.data('target'));
        var floorId = $floor.val();
        var url = $floor.data('url');

        if (!$area.length) {
            return;
        }

        if (!floorId) {
            setOptions($area, []);
            return;
        }

        $.getJSON(url + '/' + floorId, function (response) {
            setOptions($area, response.data || []);
        });
    });

    $(document).on('change', '.js-task-area-filter', function () {
        refreshTaskAreas($(this).closest('form'));
    });
})(jQuery, window, document);
